import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Lock, Smartphone, Monitor, Users, Clock, CheckCircle } from "lucide-react";
import { colors, type, spacing, radius } from "@/theme";
import { api } from "@/lib/api";
import { useRequireAuth } from "@/lib/useRequireAuth";

const BENEFITS = [
  { Icon: Smartphone, title: "Ordini dal telefono", desc: "I clienti ordinano dal proprio telefono, senza chiamare il cameriere." },
  { Icon: Monitor, title: "Cucina in tempo reale", desc: "I ticket arrivano al KDS raggruppati per tavolo, con stato di avanzamento." },
  { Icon: Users, title: "Conto unico di tavolo", desc: "Ogni commensale ordina dal proprio telefono, il conto resta unico." },
  { Icon: Clock, title: "Meno attese, più coperti", desc: "Riduci gli errori e velocizza il servizio nelle ore di punta." },
];

export default function AdminUpsell() {
  const navigate = useNavigate();
  const { user } = useRequireAuth();
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);
  if (!user) return null;

  const richiedi = async () => {
    setBusy(true); setError(null);
    try { await api.requestPro("Richiesta dal backoffice"); setDone(true); }
    catch (e) { setError(e.message); } finally { setBusy(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: colors.bg }}>
      <div style={{ maxWidth: 560, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: `${spacing.md}px ${spacing.lg}px` }}>
          <button data-testid="upsell-back" onClick={() => navigate(-1)} style={plain}><ChevronLeft size={26} color={colors.ink} /></button>
          <div style={{ ...type.serif, fontSize: 20, color: colors.ink }}>Ordinazione al tavolo</div>
          <div style={{ width: 26 }} />
        </div>
        <div style={{ padding: spacing.lg, display: "flex", flexDirection: "column", gap: spacing.md }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: spacing.sm, padding: `${spacing.md}px 0` }}>
            <div style={{ width: 64, height: 64, borderRadius: 32, background: colors.accentSoft, display: "flex", alignItems: "center", justifyContent: "center" }}><Lock size={26} color={colors.accent} /></div>
            <div style={{ ...type.serif, fontSize: 24, color: colors.ink, textAlign: "center" }}>Sblocca gli ordini dal QR</div>
            <div style={{ ...type.sans, fontSize: 14, color: colors.inkSoft, textAlign: "center", lineHeight: "21px" }}>La funzione Pro trasforma il tuo menu in un sistema di ordinazione completo con cucina in tempo reale.</div>
          </div>
          {BENEFITS.map((b) => (
            <div key={b.title} style={{ display: "flex", gap: spacing.md, alignItems: "flex-start", background: colors.surface, borderRadius: radius.lg, padding: spacing.md, border: `1px solid ${colors.line}` }}>
              <div style={{ width: 40, height: 40, borderRadius: radius.md, background: colors.accentSoft, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><b.Icon size={20} color={colors.accent} /></div>
              <div style={{ flex: 1 }}>
                <div style={{ ...type.sansSemi, fontSize: 15, color: colors.ink }}>{b.title}</div>
                <div style={{ ...type.sans, fontSize: 13, color: colors.inkSoft, marginTop: 2, lineHeight: "19px" }}>{b.desc}</div>
              </div>
            </div>
          ))}
          {done ? (
            <div style={{ display: "flex", gap: spacing.sm, alignItems: "center", background: colors.successSoft, borderRadius: radius.lg, padding: spacing.md }}>
              <CheckCircle size={22} color={colors.success} />
              <span style={{ flex: 1, ...type.sansMedium, fontSize: 14, color: colors.success, lineHeight: "20px" }}>Richiesta inviata! Ti contatteremo a breve per attivare il piano Pro.</span>
            </div>
          ) : (
            <>
              {error ? <div style={{ ...type.sansMedium, fontSize: 13, color: colors.danger, textAlign: "center" }}>{error}</div> : null}
              <button data-testid="upsell-request" onClick={richiedi} disabled={busy} style={{ background: colors.accent, height: 54, border: "none", borderRadius: radius.md, color: colors.onAccent, ...type.sansBold, fontSize: 16, marginTop: spacing.sm }}>{busy ? "…" : "Richiedi attivazione Pro"}</button>
              <div style={{ ...type.sans, fontSize: 12, color: colors.inkFaint, textAlign: "center" }}>Nessun impegno: ti spiegheremo tutto prima di attivare.</div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

const plain = { background: "none", border: "none", display: "flex", padding: 0 };
